import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
import CompanyDash from "./CompanyDashboard";
import View from "./View";

export const Company = () => {
  return (
    
      <Overview />
    
  );
};

export const AddCompany = () => {
  return (
    
      <Add />
    
  );
};

export const ViewCompany = () => {
  return (
    
      <View />
    
  );
};

export const EditCompany = () => {
  return (
    
      <Edit />
    
  );
};

export const CompanyDashboard = () => {
  return (
    
      <CompanyDash />
    
  );
};
